import { INotification } from '../../store/notifications/reducers';
import { generateUniqueKey } from '../Functions';
import { Notification } from 'api';

export const mapNotificationApiToStore = (
	notifications: Notification[]
): INotification[] =>
	notifications.map(({ timestamp, ...rest }) => {
		return {
			key: generateUniqueKey(),
			timestamp: timestamp?.split('T')[0],
			...rest,
		};
	});
